module.exports = __webpack_public_path__ + "static/img/wisdom-find.de3de07.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product/wisdom-find.jpg
// module id = 9H3i
// module chunks = 1